/**
 * @author Lefthandmedia <ralph@lefthandmedia.com>
 */
import $ from 'jquery';


class Hamburger {

  constructor() {
    var el           = new Foundation.OffCanvas($('#offCanvas'));
    this.hamburger   = document.querySelector('#hamburger');
    this.open        = false;
    this._toggleMenu = this.toggleMenu.bind(this);
    this._closeMenu = this.closeMenu.bind(this)
    this.hamburger.addEventListener('click', this._toggleMenu);
    $('[data-off-canvas]').on('closed.zf.offCanvas', this._closeMenu);
  }

  toggleMenu() {
    if (!this.open) {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  openMenu() {
    this.open = true;
    this.hamburger.classList.add('is-active');
    $('#offCanvas').foundation('open', {}, {});
  }

  closeMenu() {
    this.open = false;
    this.hamburger.classList.remove('is-active');
    $('#offCanvas').foundation('close', {}, {});
  }


}

export {Hamburger};
const hamburger = new Hamburger();




